import { Injectable } from '@angular/core';
import { BuildingTemplateCoreService } from './building-template-core.service';
import { ApiService } from '../../api/api.service';
import { TemplateService } from '../../utilities/template/template.service';
import { ApiLegacyService } from '../../api/legacy/api-legacy.service';

@Injectable({
  providedIn: 'root'
})
export class BuildingTemplateService extends BuildingTemplateCoreService {

  constructor(
    protected apiService: ApiService,
    protected apiLegacyService: ApiLegacyService,
    protected templateService: TemplateService
  ) {
    super(apiService, apiLegacyService, templateService);
  }
}
